var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7476 2.49795C5.26205 2.4569 5.75044 2.2546 6.14324 1.91985C7.05989 1.13869 8.40808 1.13869 9.32472 1.91985C9.71753 2.2546 10.2059 2.4569 10.7204 2.49795C11.9209 2.59375 12.8742 3.54707 12.97 4.7476C13.0111 5.26205 13.2134 5.75044 13.5481 6.14324C14.3293 7.05989 14.3293 8.40808 13.5481 9.32472C13.2134 9.71753 13.0111 10.2059 12.97 10.7204C12.8742 11.9209 11.9209 12.8742 10.7204 12.97C10.2059 13.0111 9.71753 13.2134 9.32472 13.5481C8.40808 14.3293 7.05989 14.3293 6.14324 13.5481C5.75044 13.2134 5.26205 13.0111 4.7476 12.97C3.54707 12.8742 2.59375 11.9209 2.49795 10.7204C2.4569 10.2059 2.2546 9.71753 1.91985 9.32472C1.13869 8.40808 1.13869 7.05989 1.91985 6.14324C2.2546 5.75044 2.4569 5.26205 2.49795 4.7476C2.59375 3.54707 3.54707 2.59375 4.7476 2.49795ZM10.6997 6.69967C11.0121 6.38725 11.0121 5.88072 10.6997 5.5683C10.3872 5.25588 9.88072 5.25588 9.5683 5.5683L6.93398 8.20261L5.89967 7.1683C5.58725 6.85588 5.08072 6.85588 4.7683 7.1683C4.45588 7.48072 4.45588 7.98725 4.7683 8.29967L6.3683 9.89967C6.68072 10.2121 7.18725 10.2121 7.49967 9.89967L10.6997 6.69967Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified2);
export default __webpack_public_path__ + "static/media/verified-2.221131336e847c3cec7ca67e430edfe8.svg";
export { ForwardRef as ReactComponent };